export default __webpack_public_path__ + "static/media/210.2125cc93.svg";